export default "__VITE_ASSET__WcUfTBlW__"